import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import { memo } from 'react';

var _templateObject;
var getOffset = function getOffset(size) {
  return "calc(100% - ".concat(size, ")");
};
var derriveCheckedLeft = function derriveCheckedLeft(_ref) {
  var _ref$toggleSize = _ref.toggleSize,
    toggleSize = _ref$toggleSize === void 0 ? 'large' : _ref$toggleSize;
  if (toggleSize === 'large') {
    return getOffset('32px');
  }
  if (toggleSize === 'medium') {
    return getOffset('24px');
  }
  return getOffset('18px');
};
var ToggleSwitchCheckbox = styled('input')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n\n  &:checked + span {\n    left: ", ";\n  }\n\n  &:not(:checked) + span {\n    left: 0%;\n    background-color: white;\n  }\n"])), derriveCheckedLeft);
var ToggleSwitchCheckbox$1 = /*#__PURE__*/memo(ToggleSwitchCheckbox);

export default ToggleSwitchCheckbox$1;
